// extracted by mini-css-extract-plugin
export default {"ProjectInvitationListItem":"ProjectInvitationListItem_ProjectInvitationListItem__Rv61H"};